'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeAreaAbbreviation = typeAreaAbbreviation;
exports.parseDistrictName = parseDistrictName;
exports.processQuery = processQuery;
exports.initCollapse = initCollapse;
exports.paserType = paserType;
exports.paserAddress = paserAddress;
exports.parseAddress = parseAddress;
exports.parseSubCat = parseSubCat;
exports.paserCategory = paserCategory;
exports.getDistanceFromLatLon = getDistanceFromLatLon;
exports.getColorRatingCode = getColorRatingCode;
exports.getAvatarReview = getAvatarReview;
exports.getAvatar = getAvatar;
exports.sliceStringTooLong = sliceStringTooLong;
exports.renderTime = renderTime;
exports.getUrlImage = getUrlImage;
exports.code2textCat = code2textCat;
exports.text2codeCat = text2codeCat;
exports.formatDate = formatDate;
exports.log = log;
exports.isMobile = isMobile;
exports.detectIos = detectIos;
exports.detectAndroid = detectAndroid;
exports.stripHtmlTags = stripHtmlTags;
exports.getOffSetLeft = getOffSetLeft;
exports.parseUrl = parseUrl;
exports.iconCat = iconCat;
exports.encrypt = encrypt;
exports.decrypt = decrypt;
exports.createImageName = createImageName;
exports.arr2Obj = arr2Obj;
exports.number2Time = number2Time;
exports.arrayTime = arrayTime;
exports.promotionPrice = promotionPrice;
exports.enterprisePrice = enterprisePrice;
exports.getPhone = getPhone;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _Constant = require('./Constant');

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _convertToHandle = require('./convertToHandle');

var _convertToHandle2 = _interopRequireDefault(_convertToHandle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ratingColorConfig = {
  worst: {
    min: 1,
    max: 2.5,
    color_code: '#ff1b1b'
  },
  bad: {
    min: 2.6,
    max: 5,
    color_code: '#FF8D1D'
  },
  normal: {
    min: 5.1,
    max: 6.9,
    color_code: '#FFB31B'
  },
  good: {
    min: 7,
    max: 7.9,
    color_code: '#AACB1F'
  },
  excellent: {
    min: 8,
    max: 10,
    color_code: '#1FCB64'
  }
};
var CryptoJS = require('crypto-js');
function typeAreaAbbreviation(type) {
  return type.split(' ').map(function (word) {
    return word[0];
  }).join('') === 'Q' ? 'Quận ' : '';
}
function parseDistrictName(area) {
  if (area && area.type && area.name) {
    if (area.name.indexOf(area.type) !== -1) {
      // TODO: Trường hợp trong name có type. Ví dụ: type = "Quận", name = "Quận 1"
      return area.name;
    }
    // TODO: Trường hợp trong name không có type
    return area.type + ' ' + area.name;
  }
}
function processQuery(query, province, district, category, subCategory, sort, location) {
  var filter = {};
  if (query) {
    filter.text_search = query;
  }
  if (province) {
    filter.province = province;
    if (district && district.length > 0) {
      filter.district = district;
    }
  }
  if (category) {
    for (var key in category) {
      if (category.hasOwnProperty(key) && category[key] !== 'none') {
        filter.category = filter.category ? filter.category : [];
        if (category[key] === 'all') {
          filter.category.push(key);
        }
        filter.category = (0, _lodash.union)(filter.category, subCategory[key]);
      }
    }
  }
  if (sort) {
    filter.sort = sort;
    if (sort === 'nearby') {
      filter.lat = location && location.latitude;
      filter.lng = location && location.longitude;
    }
  }
  return filter;
}
function initCollapse(categories) {
  var collapse = {};
  if (categories && categories.length > 0) {
    for (var index = 0; index < categories.length; index++) {
      collapse[categories[index].code] = true;
    }
  }
  return collapse;
}
function paserType(categories, categoriesFilter) {
  var types = [];
  for (var index = 0; index < categories.length; index++) {
    if (categories[index] && categoriesFilter[categories[index].code] !== 'none') {
      types.push({
        label: categories[index].label,
        code: categories[index].code
      });
    }
  }
  return types;
}
function paserAddress(districts, addressFilter) {
  var address = [];
  if (districts) {
    for (var index = 0; index < districts.length; index++) {
      if (addressFilter.indexOf(districts[index].code) !== -1) {
        address.push({
          code: districts[index].code,
          label: typeAreaAbbreviation(districts[index].type) + districts[index].name
        });
      }
    }
  }
  return address;
}

function parseAddress(districts, addressFilter) {
  var address = [];
  if (districts) {
    for (var index = 0; index < districts.length; index++) {
      if (addressFilter.indexOf(districts[index].code) !== -1) {
        address.push({
          code: districts[index].code,
          label: parseDistrictName(districts[index])
        });
      }
    }
  }
  return address;
}

function parseSubCat(categories, subCatFilter, catActive) {
  var subCategories = [];
  if (categories && categories.length > 0) {
    categories.map(function (v) {
      if (catActive === v.code) {
        var subsActive = subCatFilter[v.code];
        v.childrens.map(function (val) {
          if (subsActive.indexOf(String(val.code)) !== -1) {
            subCategories.push(val);
          }
        });
      }
    });
  }
  return subCategories;
}

function paserCategory(categories, cat) {
  var catArray = [];
  if (categories && categories.length > 0) {
    categories.forEach(function (data) {
      if (cat.indexOf(data.code) !== -1) {
        catArray.push(data.label);
      }
    });
  }
  return catArray.join(', ');
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

function getDistanceFromLatLon(lat1, lon1, lat2, lon2) {
  var radiusEarth = 6371;
  var dLat = deg2rad(lat2 - lat1);
  var dLon = deg2rad(lon2 - lon1);
  var temp = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var temp1 = 2 * Math.atan2(Math.sqrt(temp), Math.sqrt(1 - temp));
  var distanceInKm = radiusEarth * temp1;
  return distanceInKm * 1000;
}

function getColorRatingCode(point) {
  var colorRatingCode = '#DDDDDD';
  var ratingColor = ratingColorConfig;
  for (var ratingRange in ratingColor) {
    if (ratingColor.hasOwnProperty(ratingRange)) {
      if (point <= ratingColor[ratingRange].max && point >= ratingColor[ratingRange].min) {
        colorRatingCode = ratingColor[ratingRange].color_code;
      }
    }
  }
  return colorRatingCode;
}
function getAvatarReview(user) {
  var avt = _Constant.defaultAvatar;
  if (user && user.profile && user.profile.picture) {
    var url = user.profile.picture;
    avt = url.indexOf('http') !== -1 ? url : '/upload/' + url;
  }
  return avt;
}
function getAvatar(user) {
  var avt = _Constant.defaultAvatar;
  if (user && user.profile && user.profile.picture) {
    var url = user.profile.picture;
    avt = url.indexOf('http') !== -1 ? url : '/upload/' + url;
  }
  return avt;
}

function sliceStringTooLong(str, maxLength) {
  var result = str;
  if (str.length >= maxLength) {
    result = str.slice(0, maxLength) + '...';
  }
  return result;
}
function renderTime(time) {
  var date = new Date(time);
  var diff = Math.abs(new Date() - date);
  var minutes = Math.floor(diff / 60000);
  if (minutes < 60) return minutes + ' phút trước';
  var hour = Math.floor(minutes / 60);
  if (hour < 24) return hour + ' giờ trước';
  var day = Math.floor(hour / 24);
  if (day < 7) return day + ' ngày trước';
  return (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '/' + (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/' + date.getFullYear();
}
function getUrlImage(url) {
  if (url.indexOf('http') !== -1) {
    return url;
  }
  return '/upload/' + url;
}

function code2textCat(codes, cats) {
  if (codes && cats) {
    var catText = [];
    codes.map(function (value) {
      for (var index = 0; index < cats.length; index++) {
        if (cats[index].link === value || cats[index].code === value) {
          catText.push(cats[index].link);
        }
      }
    });
    return catText;
  }
  return [];
}

function text2codeCat(codes, cats) {
  if (codes && cats) {
    var catCode = [];
    codes.map(function (value) {
      for (var index = 0; index < cats.length; index++) {
        if (cats[index].link === value || cats[index].code === value) {
          // Tránh trường hợp code củ chạy không đúng
          catCode.push(cats[index].code);
        }
      }
    });
    return catCode;
  }
  return [];
}

function formatDate(dateInput) {
  if (!dateInput) return '';
  var dateObject = new Date(dateInput);
  var date = dateObject.getDate();
  var dateFormat = date < 10 ? '0' + date : date;
  var month = dateObject.getMonth() + 1;
  var monthFormat = month < 10 ? '0' + month : month;
  var year = dateObject.getFullYear();
  return dateFormat + '/' + monthFormat + '/' + year;
}

function log() {
  for (var i = 0; i < arguments.length; ++i) {
    console.log(arguments[i]);
  }
}
function isMobile() {
  return global.navigator && /iPad|iPhone|iPod|Android|BlackBerry|Windows Phone|webOS/.test(global.navigator.userAgent);
}

function detectIos() {
  return (/iPad|iPhone|iPod/.test(navigator.userAgent)
  );
}

function detectAndroid() {
  return (/android/i.test(navigator.userAgent)
  );
}

function stripHtmlTags(str) {
  return (0, _lodash.isString)(str) ? str.replace(/<[^>]*>/g, '') : '';
}

// export function number2Time(number) {
//   const hour = parseInt(parseInt(number, 10) / 60, 10);
//   let min = parseInt(number % 60, 10);
//   if ( min < 10) {
//     min = '0' + min;
//   }
//   if (hour > 12) {
//     return (hour - 12) + ':' + min + 'PM';
//   }
//   return hour + ':' + min + 'AM';
// }
function getOffSetLeft(elem) {
  // TODO: Lấy khoảng cách từ offSetLeft tới body
  var ele = elem || null;
  if (ele === null) {
    return 0;
  }
  var offsetLeft = 0;
  do {
    if (!isNaN(elem.offsetLeft)) {
      offsetLeft += ele.offsetLeft;
    }
    ele = ele.offsetParent;
  } while (ele !== null);
  return offsetLeft;
}

function parseUrl(query) {
  if (query === undefined) {
    return '';
  }
  var array = [];
  for (var key in query) {
    if (query.hasOwnProperty(key)) {
      array.push(key + '=' + query[key]);
    }
  }
  return array.join('&');
}
function iconCat(code, catActive) {
  switch (code) {
    case '01':
      return catActive === '01' ? _react2.default.createElement('img', { src: _Images2.default.cats.spa }) : _react2.default.createElement('img', { src: _Images2.default.cats.spaInactive });
    case '02':
      return catActive === '02' ? _react2.default.createElement('img', { src: _Images2.default.cats.hair }) : _react2.default.createElement('img', { src: _Images2.default.cats.hairInactive });
    case '03':
      return catActive === '03' ? _react2.default.createElement('img', { src: _Images2.default.cats.cosmetic }) : _react2.default.createElement('img', { src: _Images2.default.cats.cosmeticInactive });
    case '04':
      return catActive === '04' ? _react2.default.createElement('img', { src: _Images2.default.cats.clinic }) : _react2.default.createElement('img', { src: _Images2.default.cats.clinicInactive });
    case '05':
      return catActive === '05' ? _react2.default.createElement('img', { src: _Images2.default.cats.fitness }) : _react2.default.createElement('img', { src: _Images2.default.cats.fitnessInactive });
    case '06':
      return catActive === '06' ? _react2.default.createElement('img', { src: _Images2.default.cats.tatoo }) : _react2.default.createElement('img', { src: _Images2.default.cats.tatooInactive });
    case '07':
      return catActive === '07' ? _react2.default.createElement('img', { src: _Images2.default.cats.homeService }) : _react2.default.createElement('img', { src: _Images2.default.cats.homeServiceInactive });
    case 'M1':
      return catActive === 'M1' ? _react2.default.createElement('img', { src: _Images2.default.cats.salonMiMong }) : _react2.default.createElement('img', { src: _Images2.default.cats.salonMiMongInactive });
    case 'M2':
      return catActive === 'M2' ? _react2.default.createElement('img', { src: _Images2.default.cats.spaChamDa }) : _react2.default.createElement('img', { src: _Images2.default.cats.spaChamDaInactive });
    case 'M3':
      return catActive === 'M3' ? _react2.default.createElement('img', { src: _Images2.default.cats.massageGoiDau }) : _react2.default.createElement('img', { src: _Images2.default.cats.massageGoiDauInactive });
    case 'M4':
      return catActive === 'M4' ? _react2.default.createElement('img', { src: _Images2.default.cats.thamMyNhaKhoa }) : _react2.default.createElement('img', { src: _Images2.default.cats.thamMyNhaKhoaInactive });
    case 'M5':
      return catActive === 'M5' ? _react2.default.createElement('img', { src: _Images2.default.cats.salonTocMakeUp }) : _react2.default.createElement('img', { src: _Images2.default.cats.salonTocMakeUpInactive });
    case 'M6':
      return catActive === 'M6' ? _react2.default.createElement('img', { src: _Images2.default.cats.hoiThao }) : _react2.default.createElement('img', { src: _Images2.default.cats.hoiThaoInactive });
    case 'M7':
      return catActive === 'M7' ? _react2.default.createElement('img', { src: _Images2.default.cats.khoaHoc }) : _react2.default.createElement('img', { src: _Images2.default.cats.khoaHocInactive });
    default:
      break;
  }
}

function encrypt(text) {
  var secrect = _config2.default.cryptoSecret ? _config2.default.cryptoSecret : '123qwe';
  return CryptoJS.AES.encrypt(text, secrect).toString();
}

function decrypt(text) {
  var secrect = _config2.default.cryptoSecret ? _config2.default.cryptoSecret : '123qwe';
  if (!text) return false;
  try {
    var bytes = CryptoJS.AES.decrypt(text.toString(), secrect);
    var result = bytes.toString(CryptoJS.enc.Utf8);
    return result;
  } catch (err) {
    console.log(err, 'error');
    return text;
  }
}

function createImageName(_ref) {
  var name = _ref.name,
      street = _ref.street,
      ward = _ref.ward,
      district = _ref.district,
      province = _ref.province,
      type = _ref.type,
      user = _ref.user;

  var names = [];
  if (name) {
    names.push((0, _convertToHandle2.default)(name));
  }
  if (street) {
    names.push((0, _convertToHandle2.default)(street));
  }
  if (ward) {
    names.push((0, _convertToHandle2.default)(ward));
  }
  if (district) {
    names.push((0, _convertToHandle2.default)(district));
  }
  if (province) {
    names.push((0, _convertToHandle2.default)(province));
  }
  if (user) {
    names.push((0, _convertToHandle2.default)(user));
  }
  names.push('lookme.vn');
  switch (type) {
    case 'shop':
      return 'shop-' + (0, _convertToHandle2.default)(name) + '/' + names.join('-');
    case 'review':
    case 'collection':
    case 'seo':
    case 'voucher':
    case 'packageService':
      return type + '-' + (0, _convertToHandle2.default)(name) + '/' + names.join('-');
    case 'avatar':
      return 'avatar/' + names.join('-');
    default:
      return names.join('-');
  }
}

function arr2Obj(arrays, field) {
  var obj = {};
  if (!Array.isArray(arrays)) {
    return {};
  }
  try {
    arrays.map(function (item, index) {
      if (field && item[field]) {
        obj[item[field]] = item;
      } else {
        obj[index] = item;
      }
    });
    return obj;
  } catch (err) {
    console.log(err);
    return {};
  }
}

function number2Time(number) {
  var hour = parseInt(parseInt(number, 10) / 60, 10);
  var min = parseInt(number % 60, 10);
  if (min < 10) {
    min = '0' + min;
  }
  if (hour > 12) {
    return hour - 12 + ':' + min + ' PM';
  }
  if (hour === 12) {
    return hour + ':' + min + ' PM';
  }
  return hour + ':' + min + ' AM';
}

function arrayTime() {
  // Với step là 30 phút, time chạy từ 00 -> 23h30 sẽ có 47 khoảng.
  var step = 30;
  var result = [];
  for (var i = 0; i < 48; i++) {
    var item = { label: number2Time(i * step), value: i * step };
    result.push(item);
  }
  return result;
}

function promotionPrice(card) {
  if (card) {
    switch (card.typePromotion) {
      case 'free':
        return 0;
      case 'newPrice':
        return card.newPrice;
      case 'percent':
        return card.percent * card.onePackage.service.price / 100;
      case 'discount':
        return card.onePackage.service.price - card.valueDiscount;
      default:
        break;
    }
  }
  return '';
}

function enterprisePrice(coupon, service) {
  if (coupon && service) {
    switch (coupon.typePromotion) {
      case 'free':
        return 0;
      case 'newPrice':
        return coupon.newPrice;
      case 'percent':
        return coupon.percent * service.price / 100;
      case 'discount':
        return service.price - coupon.valueDiscount;
      default:
        break;
    }
  }
}

function getPhone(str) {
  if (!str) return '';
  var _str = str;
  var regex = new RegExp('[+]?[(]?[0-9]{3}[)]?[-s.]?[0-9]{3}[-s.]?[0-9]{4,6}');
  _str = _str.replace(/ /g, '');
  _str = _str.replace(/\./g, '');
  _str = _str.replace(/\(/g, '');
  _str = _str.replace(/\)/g, '');
  var phone = regex.exec(_str);
  if (phone.length === 0) return '';
  return phone[0];
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/lib.js
// module id = 18
// module chunks = 0